
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getUsers(params = null) {
        if (params && typeof params === 'string') {
            return axios.get(params, { headers: authHeader() });
        }
        const query = new URLSearchParams();
        if (params && typeof params === 'object') {
            if (params.search) query.set('search', params.search);
            if (params.page) query.set('page', params.page);
        }
        const qs = query.toString();
        const url = qs ? `${API_URL}/users?${qs}` : `${API_URL}/users`;
        return axios.get(url, { headers: authHeader() });
    },
    getAll(pageUrl=null) {
        const url = `${API_URL}/users?page=${pageUrl}`; 
        return axios.get(url, { headers: authHeader() });
    },
    search(filter=null) {
        const url = `${API_URL}/users/search?filter=${filter}`; 
        return axios.get(url, { headers: authHeader() });
    },
    getUser(userId) {
        return axios.get(`${API_URL}/users/${userId}`, { headers: authHeader() });
    },
    createUser(userData) {
        return axios.post(`${API_URL}/users`, userData, { headers: authHeader() });
    },
    updateUser(userId, userData) {
        return axios.put(`${API_URL}/users/${userId}`, userData, { headers: authHeader() });
    },
    deleteUser(userId) {
        return axios.delete(`${API_URL}/users/${userId}`, { headers: authHeader() });
    },
    getOilReminders() {
        return axios.get(`${API_URL}/users/oil-reminders`, { headers: authHeader() });
    },
    markOilReminderSent(userId) {
        return axios.post(`${API_URL}/users/${userId}/oil-reminder-sent`, {}, { headers: authHeader() });
    },
    getOficios() {
        const url = `${API_URL}/oficios`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
};